module.exports = __webpack_public_path__ + "img/Logo_Mind2_DrThumm_RZ_rgb.5140c309.png";